import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { customAssetsUrl } from '@app/app.constants';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'portal-footer',
  templateUrl: './portal-footer.component.html',
  styleUrls: ['./portal-footer.component.scss'],
  standalone: false,
})
export class PortalFooterComponent implements OnInit {
  @ViewChild('footer', { static: true })
  public footer: ElementRef<HTMLElement>;

  public footerContent: SafeHtml;

  private rawFooterContent: string = '';

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private domSanitizer: DomSanitizer,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.watchFooter();

    this.http
      .get(customAssetsUrl('/assets/html/footer.html'), {
        responseType: 'text',
      })
      .pipe(delay(0))
      .subscribe((html) => {
        this.footerContent = this.domSanitizer.bypassSecurityTrustHtml(html);
        this.rawFooterContent = html;
      });
  }

  private watchFooter() {
    // Create a mutation observer that is called whenever the innerHTML of the footer changes. The
    // callback function will then iterate over the content of the footer and recreate all script
    // tags so they are executed.
    const mutationObserver = new MutationObserver(() => {
      const node = document.createElement('div');
      node.innerHTML = this.rawFooterContent;

      node.childNodes.forEach((node: Element) => {
        if (node.nodeName === 'SCRIPT') {
          const scriptTag = document.createElement('script');
          const scriptContent = document.createTextNode(node.innerHTML);

          scriptTag.appendChild(scriptContent);

          document.getElementsByTagName('head')[0].appendChild(scriptTag);
        }
      });
    });

    // Watch for changes on the footer element.
    mutationObserver.observe(this.footer.nativeElement, {
      characterData: true,
      childList: true,
    });
  }
}
